// extracted by mini-css-extract-plugin
export default {"cartContainer":"GenericDrawer_cartContainer__dd7oW","cartItem":"GenericDrawer_cartItem__51Sat"};